export default {
    'name': 'html',
    'width': '45',
    'height': '41',
    'viewBox': '0 0 41 45',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 12.2015V42H37.3333V0H11.8018L0 12.2015Z\' fill=\'#006CFD\'/><rect width=\'36\' height=\'15\' transform=\'translate(4.66675 20)\' fill=\'#C1E8FD\'/><path d=\'M8.88886 32V25H10.1489V27.87H13.7589V25H15.0189V32H13.7589V28.9H10.1489V32H8.88886ZM18.5229 32V26.03H16.1929V25H22.1329V26.03H19.7829V32H18.5229ZM23.2885 32V25H24.6885L27.0485 29.51L29.3885 25H30.7585V32H29.6385V26.74L27.5785 30.68H26.4985L24.4185 26.75V32H23.2885ZM32.6904 32V25H33.9504V30.97H37.4104V32H32.6904Z\' fill=\'#0158CE\'/>'
}
